<template>
  <div class="cnc-badge-number">
    <span v-if="number > 0" :class="`badge-number ${sizeBadge[size]}  ${outline ? 'badge-outline' : ''}`">
      <span v-if="currency" data-qa="txt-currency">{{ currency }}</span>
      <span data-qa="txt-val">{{ trimmedNumber }}</span>
    </span>
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    number: { type: Number },
    isAbbreviated: { type: Boolean },
    size: { type: String, default: 'large' },
    currency: { type: String },
    outline: { type: Boolean },
  },
  data () {
    return {
      sizeBadge: {
        'large': 'badge-number-large',
        'medium': 'badge-number-medium',
        'small': 'badge-number-small',
        'extra-small': 'badge-number-extra-small'
      }
    }
  },
  computed: {
    trimmedNumber () {
      if (this.isAbbreviated) return this.number > 999 ? this.abbreviateNumber(this.number) : this.number
      else return this.number > 999 ? '999+' : this.number
    }
  },
  methods: {
    abbreviateNumber (num) {
      const abbreviations = ['', 'K', 'M', 'B', 'T']
      const numString = num.toString()
      const abbreviationIndex = Math.floor((numString.length - 1) / 3)
      const abbreviatedNumber = (num / Math.pow(1000, abbreviationIndex)).toFixed(2)
      const roundedNumber = parseFloat(abbreviatedNumber)
      return roundedNumber.toString() + abbreviations[abbreviationIndex]
    }
  }
}
</script>

<style lang="scss">
.cnc-badge-number {
  span.badge-number {
    background-color: $color-primary-500;
    color: $color-white;
    border-radius: 999px;
    display: inline-block;

    &.badge-number-large {
      font-size: $text-base-px;
      padding: 2px 10px;
      min-width: 28px;
      min-height: 28px;
    }

    &.badge-number-medium {
      font-size: $text-sm-px;
      padding: 1px 8px;
      min-width: 24px;
      min-height: 24px;
    }

    &.badge-number-small {
      font-size: $text-xs-px;
      padding: 1px 7px;
      min-width: 20px;
      min-height: 20px;
    }

    &.badge-number-extra-small {
      font-size: $text-2xs-px;
      padding: 1px 6px;
      min-width: 16px;
      min-height: 16px;
    }

    &.badge-outline {
      outline: 2px solid $color-white;
    }
  }
}
</style>
